<template>
  <div id="app">
    <!-- <keep-alive :include="include">
      <router-view id="page" :style="height" />
    </keep-alive> -->
    <navigation>
      <router-view id="page" :style="height"></router-view>
    </navigation>

    <commentReplySet v-if="CommentSetShow.show" />
    <launchWeapp v-if="LaunchWeappShow" />
    <div id="CB_B_398"></div>
    <div id="CB_B_red"></div>
  </div>
</template>

<script>
import { rem } from "./public/rem";
import commentReplySet from "./page/comment/ReplySet";
export default {
  components: {
    commentReplySet,
  },
  name: "App",
  data() {
    return {
      include:
        "orderEditAddress,myOrder,service,Collage,goods,pay,addTiku,tikuindex,exam,choice,topic,comment,Reply,random,result,cuoti,biji,shoucang,pinglun,year,my",
    };
  },
  created() {
    rem(this);
    localStorage.setItem("wxShreUrl", location.href.split("#")[0]);
  },
  mounted() {
    this.VConsole_show();

    let loading = document.getElementById("Loading");
    if (loading != null) {
      document.body.removeChild(loading);
    }
  },
  methods: {},
  computed: {
    LaunchWeappShow() {
      return this.$store.getters["event/getLaunchWeapp"].show;
    },
    height() {
      return this.$store.getters.getHeight;
    },
    CommentSetShow() {
      return this.$store.getters.getCommentSetShow;
    },
  },
};
</script>

<style lang="scss">
#CB_B_398 {
  .van-dialog__confirm {
    .van-button__content {
      background-color: #3982f7;
      color: #fff;
    }
  }
}
#CB_B_red {
  .van-dialog__confirm {
    .van-button__content {
      background-color: red;
      color: #fff;
    }
  }
}
// *{
//    filter: invert(1);
// }
.record {
  position: relative;
}
.pre-wrap {
  white-space: pre-line;
  word-break: break-all;
}
.record::after {
  position: absolute;
  top: 0;
  right: 0;
  content: " ";
  transform: translate(100%, -50%);
  width: 1.7rem;
  height: 0.75rem;
  background-image: url(./image/icon_doing_continue.png);
  background-size: 1.7rem 0.75rem;
}
#__vconsole {
  // display: none;
}
.nav-srcoll {
  overflow-y: auto;
  height: calc(100% - 2.2rem);
}
body {
  margin: 0;
}
#page {
  overflow: auto;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.m-a {
  margin: auto;
}
.layout-row {
  display: flex;
  flex-direction: row;
}
.layout-col {
  display: flex;
  flex-direction: column;
}
.font-21-fff {
  font-size: 1.05rem;
  color: #fff;
}
.font-10-000 {
  font-size: 0.5rem;
  color: #000;
}
.font-15-000 {
  font-size: 0.75rem;
  color: #000;
}
.font-13-000 {
  font-size: 0.65rem;
  color: #000;
}
.font-17-333 {
  font-size: 0.85rem;
  color: #333;
}
.font-12-fff {
  font-size: 0.6rem;
  color: #fff;
}
.font-11-999 {
  font-size: 0.55rem;
  color: #999;
}
.font-13-fff {
  font-size: 0.65rem;
  color: #fff;
}
.font-18-fff {
  font-size: 0.9rem;
  color: #fff;
}
.font-30-fff {
  font-size: 1.5rem;
  color: #fff;
}
.font-11-666 {
  font-size: 0.55rem;
  color: #666;
}
.font-16-000 {
  font-size: 0.8rem;
  color: #000;
}
.font-10-ff6 {
  font-size: 0.5rem;
  color: #ff6a63;
}
.font-14-000 {
  font-size: 0.7rem;
  color: #000;
}
.font-18-333 {
  font-size: 0.9rem;
  color: #333;
}
.font-14-999 {
  font-size: 0.7rem;
  color: #999;
}
.font-14-333 {
  font-size: 0.7rem;
  color: #333;
}
.font-14-666 {
  font-size: 0.7rem;
  color: #666;
}
.font-15-333 {
  font-size: 0.75rem;
  color: #333;
}
.font-15-666 {
  font-size: 0.75rem;
  color: #666;
}
.font-15-999 {
  font-size: 0.75rem;
  color: #999;
}
.font-15-000 {
  font-size: 0.75rem;
  color: #000;
}
.font-18-000 {
  font-size: 0.9rem;
  color: #000;
}
.font-15-ccc {
  font-size: 0.75rem;
  color: #ccc;
}
.font-16-333 {
  font-size: 0.8rem;
  color: #333;
}
.font-16-666 {
  font-size: 0.8rem;
  color: #666;
}
.font-13-666 {
  font-size: 0.65rem;
  color: #666;
}
.font-13-333 {
  font-size: 0.65rem;
  color: #333;
}
.font-22-398 {
  font-size: 1.1rem;
  color: #3982f7;
}
.font-12-666 {
  font-size: 0.6rem;
  color: #666;
}
.font-12-333 {
  font-size: 0.6rem;
  color: #333;
}
.font-10-666 {
  font-size: 0.5rem;
  color: #666;
}
.font-14-fff {
  font-size: 0.7rem;
  color: #fff;
}
.font-15-fff {
  font-size: 0.75rem;
  color: #fff;
}
.font-10-fff {
  font-size: 0.5rem;
  color: #fff;
}
.font-13-999 {
  font-size: 0.65rem;
  color: #999;
}
.font-10-333 {
  font-size: 0.5rem;
  color: #333;
}
.b {
  font-weight: 400;
}
.f-c {
  align-items: center;
}
.f-j-c {
  justify-content: center;
}
.f-e {
  align-items: flex-end;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.font-12-398 {
  font-size: 0.6rem;
  color: #3982f7;
}
.f-j-b {
  justify-content: space-between;
}
.Collage {
  .swiper-wrapper {
    display: block;
  }
}
.font-12-fd5 {
  color: #fd5b54;
  font-size: 0.6rem;
}
.font-13-fd5 {
  color: #fd5b54;
  font-size: 0.65rem;
}
.font-16-fff {
  font-size: 0.8rem;
  color: #fff;
}
.font-34-fff {
  font-size: 1.7rem;
  color: #fff;
}
.font-12-999 {
  font-size: 0.6rem;
  color: #999;
}
.font-24-333 {
  font-size: 1.2rem;
  color: #333;
}
.font-13-398 {
  font-size: 0.65rem;
  color: #3982f7;
}
.font-14-398 {
  font-size: 0.7rem;
  color: #3982f7;
}
.font-16-ff8 {
  font-size: 0.8rem;
  color: #ff8932;
}
.font-10-999 {
  font-size: 0.5rem;
  color: #999;
}
.font-15-000 {
  font-size: 0.75rem;
  color: #000;
}
.font-12-000 {
  font-size: 0.6rem;
  color: #000;
}
.f-j-e {
  justify-content: flex-end;
}

.van-nav-bar .van-icon {
  color: #333333;
}
.font-25-333 {
  font-size: 1.25rem;
  color: #333;
}

.spanclamp {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.tab1 {
  .van-tab {
    font-size: 0.75rem;
    padding: 0 15px;
    color: #000;
    flex: none;
  }
  .van-tab--active {
    font-size: 0.8rem;
    font-weight: bold;
    color: #000;
  }
  .van-tab:nth-last-child(2) {
    margin-right: 5.5rem;
  }
}
.bold {
  font-weight: bold;
}
.tab2 {
  padding: 0;
  border-bottom: 1px solid #f8f8f8;
  .van-tab {
    transition: all 0.1s;
    font-size: 14px;

    color: #666;
    // width: 3.95rem;
    height: 1.4rem;
    background: #fff;
    border-radius: 0.7rem;
    // margin-left: 0.5rem;
    box-sizing: border-box;
    margin: 0.4rem 0.25rem;
    -webkit-box-flex: none;
    -webkit-flex: none;
    flex: none;
    padding: 0 0.55rem;
  }
  .van-tab--active {
    color: #fff;
    background: #3982f7;
  }
  .van-tabs__line {
    display: none;
  }
}

.divS {
  height: 100%;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue